import React from "react";
import "../../../styles/contactos.css";
import tel from "../../../imgs/Icons/tel.svg";
import fax from "../../../imgs/Icons/fax.svg";
import email from "../../../imgs/Icons/email.svg";
import morada from "../../../imgs/Icons/morada.svg";
import site from "../../../imgs/Icons/site.svg";
import { withNamespaces } from "react-i18next";

const EntidadesParc = ({ t }) => {
  
  const formatPhoneValues = (phoneNumber) => {
    phoneNumber = phoneNumber.replace(/[^\d]/g, '');
    return `+351 ${phoneNumber.slice(0, 3)} 
  ${phoneNumber.slice(3, 6)} ${phoneNumber.slice(6, 9)}`
  }

  return (
    <>
      <div
        className="accordion accordions_margin"
        id="accordionExample_entidades"
      >
        {/* 1 - INSTITUTO CONFUCIO */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="iConfucio">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cIConfucio"
              aria-expanded="true"
              aria-controls="cIConfucio"
            >
              {t('moduleContactosEstruturas:S6.A.A1.T')}
            </button>
          </h2>
          <div
            id="cIConfucio"
            className="accordion-collapse collapse"
            aria-labelledby="iConfucio"
            data-bs-parent="#accordionExample_entidades"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S6.A.A1.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S6.A.A1.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S6.A.A1.P2')}>
                    {t('moduleContactosEstruturas:S6.A.A1.P2')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    href={t('moduleContactosEstruturas:S6.A.A1.P3')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('moduleContactosEstruturas:S6.A.A1.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S6.A.A1.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 2 - AAUAv */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="aauav">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cAauav"
              aria-expanded="true"
              aria-controls="cAauav"
            >
              {t('moduleContactosEstruturas:S6.A.A2.T')}
            </button>
          </h2>
          <div
            id="cAauav"
            className="accordion-collapse collapse"
            aria-labelledby="aauav"
            data-bs-parent="#accordionExample_entidades"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S6.A.A2.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S6.A.A2.P1'))}
                  </a>
                </p>
                <p>
                  <img src={fax} alt={t('moduleContactosEstruturas:Alt.Alt3')}></img>
                  <a className="link" rel="noreferrer" href={"fax:+351" +
                    t('moduleContactosEstruturas:S6.A.A2.P2')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S6.A.A2.P2'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S6.A.A2.P3')}>
                    {t('moduleContactosEstruturas:S6.A.A2.P3')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    href={t('moduleContactosEstruturas:S6.A.A2.P4')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('moduleContactosEstruturas:S6.A.A2.P4')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S6.A.A2.P5')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 3 - ESN */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="esn">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cEsn"
              aria-expanded="true"
              aria-controls="cEsn"
            >
              {t('moduleContactosEstruturas:S6.A.A3.T')}
            </button>
          </h2>
          <div
            id="cEsn"
            className="accordion-collapse collapse"
            aria-labelledby="esn"
            data-bs-parent="#accordionExample_entidades"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S6.A.A3.P1')}>
                    {t('moduleContactosEstruturas:S6.A.A3.P1')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    href={t('moduleContactosEstruturas:S6.A.A3.P2')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('moduleContactosEstruturas:S6.A.A3.P2')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S6.A.A3.P3')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 4 - NCPLP */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="ncplp">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cNcplp"
              aria-expanded="true"
              aria-controls="cNcplp"
            >
              {t('moduleContactosEstruturas:S6.A.A4.T')}
            </button>
          </h2>
          <div
            id="cNcplp"
            className="accordion-collapse collapse"
            aria-labelledby="ncplp"
            data-bs-parent="#accordionExample_entidades"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S6.A.A4.P1')}>
                    {t('moduleContactosEstruturas:S6.A.A4.P1')}
                  </a>
                </p>
                <p className="break_line">
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    href={t('moduleContactosEstruturas:S6.A.A4.P2')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('moduleContactosEstruturas:S6.A.A4.P2')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S6.A.A4.P3')}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 5 - AECAV */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="aecav">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cAecav"
              aria-expanded="true"
              aria-controls="cAecav"
            >
              {t('moduleContactosEstruturas:S6.A.A5.T')}
            </button>
          </h2>
          <div
            id="cAecav"
            className="accordion-collapse collapse"
            aria-labelledby="aecav"
            data-bs-parent="#accordionExample_entidades"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a
                    className="link"
                    href={"mailto:" + t('moduleContactosEstruturas:S6.A.A5.P1')}>
                    {t('moduleContactosEstruturas:S6.A.A5.P1')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    href={t('moduleContactosEstruturas:S6.A.A5.P2')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('moduleContactosEstruturas:S6.A.A5.P2')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 6 - AMOAV */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="amoav">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cAmoav"
              aria-expanded="true"
              aria-controls="cAmoav"
            >
              {t('moduleContactosEstruturas:S6.A.A6.T')}
            </button>
          </h2>
          <div
            id="cAmoav"
            className="accordion-collapse collapse"
            aria-labelledby="amoav"
            data-bs-parent="#accordionExample_entidades"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S6.A.A6.P1')}>
                    {t('moduleContactosEstruturas:S6.A.A6.P1')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 7 - AESTPAV */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="aestpav">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cAestpav"
              aria-expanded="true"
              aria-controls="cAestpav"
            >
              {t('moduleContactosEstruturas:S6.A.A7.T')}
            </button>
          </h2>
          <div
            id="cAestpav"
            className="accordion-collapse collapse"
            aria-labelledby="aestpav"
            data-bs-parent="#accordionExample_entidades"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S6.A.A7.P1')}>
                    {t('moduleContactosEstruturas:S6.A.A7.P1')}
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* 8 - CUFC */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="cufc">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#cCufc"
              aria-expanded="true"
              aria-controls="cCufc"
            >
              {t('moduleContactosEstruturas:S6.A.A8.T')}
            </button>
          </h2>
          <div
            id="cCufc"
            className="accordion-collapse collapse"
            aria-labelledby="cufc"
            data-bs-parent="#accordionExample_entidades"
          >
            <div className="accordion-body">
              <div className="p_accordion marginB-p">
                <p>
                  <img src={tel} alt={t('moduleContactosEstruturas:Alt.Alt2')}></img>
                  <a className="link" rel="noreferrer" href={"tel:+351" +
                    t('moduleContactosEstruturas:S6.A.A8.P1')}>
                    {formatPhoneValues(t('moduleContactosEstruturas:S6.A.A8.P1'))}
                  </a>
                </p>
                <p>
                  <img src={email} alt={t('moduleContactosEstruturas:Alt.Alt4')}></img>
                  <a className="link" href={"mailto:" + t('moduleContactosEstruturas:S6.A.A8.P2')}>
                    {t('moduleContactosEstruturas:S6.A.A8.P2')}
                  </a>
                </p>
                <p>
                  <img src={site} alt={t('moduleContactosEstruturas:Alt.Alt1')}></img>
                  <a
                    className="link"
                    href={t('moduleContactosEstruturas:S6.A.A8.P3')}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {t('moduleContactosEstruturas:S6.A.A8.P3')}
                  </a>
                </p>
                <p>
                  <img src={morada} alt={t('moduleContactosEstruturas:Alt.Alt5')}></img>{t('moduleContactosEstruturas:S6.A.A8.P4')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withNamespaces()(EntidadesParc);

